export const brainModuleOverview = [
  {
    id: "anatomy",
    title: "Brain Anatomy",
    description: "Cerebrum, cerebellum, brainstem",
    icon: "🧠",
    customImage: "module-brain-anatomy.png",
    gradient: "from-purple-100 via-violet-50 to-indigo-100 border-purple-300",
  },
  {
    id: "lobes",
    title: "Brain Lobes",
    description: "Frontal, Parietal, Temporal, Occipital",
    icon: "🎯",
    customImage: "module-brain-lobes.png",
    gradient: "from-indigo-100 via-blue-50 to-purple-100 border-indigo-300",
  },
  {
    id: "neurons",
    title: "Neurons & Synapses",
    description: "How brain cells communicate",
    icon: "⚡",
    customImage: "module-brain-neurons.png",
    gradient: "from-cyan-100 via-blue-50 to-teal-100 border-cyan-300",
  },
  {
    id: "cranialnerves",
    title: "Cranial Nerves",
    description: "12 pairs of cranial nerves",
    icon: "🔌",
    customImage: "module-brain-nerves.png",
    gradient: "from-teal-100 via-emerald-50 to-green-100 border-teal-300",
  },
  {
    id: "physiology",
    title: "Brain Physiology",
    description: "Neural function and signaling",
    icon: "⚡",
    gradient: "from-purple-100 via-violet-50 to-indigo-100 border-purple-300",
  },
];
